<template>
    <div>
        <label>
            <span>File</span>
            <i class="fa fa-info-circle text-muted" data-toggle="tooltip" data-placement="right" :title="info"></i>
        </label>

        <div class="thumb-wrapper">
            <div class="file-thumb-container mb-2" v-if="file" :title="file.filename">
                <div class="file-thumb" v-html="file.thumb" @click="handleClick"></div>
                <div class="file-name">
                    <a :href="file.cached_file" target="__blank">{{ file.name }}</a>
                </div>
            </div>

            <p v-else class="text-muted mb-1">No file chosen</p>

            <div class="button-container">
                <select-button classe="select-button btn btn-secondary btn-sm"><i class="fa fa-folder-open" aria-hidden="true"></i> Select file</select-button>
                <upload-button classe="upload-button btn btn-secondary btn-sm"><i class="fa fa-upload" aria-hidden="true"></i> Upload file</upload-button>
                <button class="btn btn-danger btn-sm w-100" @click.prevent="handleDelete"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button>
            </div>
        </div>

        <select-modal
            title="Select file"
            :detail="true"
            :brand-options="brandOptions"
            :countries="countries"
            :agreement-country="agreementCountry"
            :accessCountries="accessCountries"
            ></select-modal>
        <upload-modal
            title="Upload file"
            :attachmentBrand="attachmentBrand"
            :detail="true"
            :is-local="isLocal"
            :type-files="typeFiles"
            :type-numbers="typeNumbers"
            :countries="countries"
            :agreement-country="agreementCountry"
            ></upload-modal>
        <input type="hidden" name="document_id" :value="documentId" />
    </div>
</template>

<script>
import Modal from "../Modal";
import { EventBus } from '../../event-bus.js';
import SelectButton from './SelectButton.vue';
import UploadButton from './UploadButton.vue';
import SelectModal from './SelectModal.vue';
import UploadModal from './UploadModal.vue';

export default {
    name: 'FileThumb',
    components: {
        Modal,
        SelectButton,
        UploadButton,
        SelectModal,
        UploadModal
    },
    props: {
        document: { type:Object, default:null, required:false },
        isLocal: { type:Boolean, default:false, required:false },
        info: { type:String, required:true },
        attachmentBrand: { type:Number, default:null, required: false},
        typeFiles: { type:Array, required:true},
        typeNumbers: { type:Object, required:true},
        brandOptions: { type:Array, required:true},
        countries: { type:Array, required:true},
        agreementCountry: { type:Number, required:true},
        accessCountries: { type:Boolean, required:true}
    },
    computed: {
        documentId() {

            return this.file?.id || null;
        },
    },
    data() {
        return {
            file: this.$props.document,
        }
    },
    methods: {
        handleClick() {
            window.open(this.file.cached_file,'__blank');
        },
        handleDelete() {
            this.file = null;
        }
    },
    created() {
        EventBus.$on('detailFileChanged', (document) => {
            if(document) {
                this.file = document;
            }
        });
    }
}
</script>

<style scoped>
.thumb-wrapper {
    width: 200px;
}
.file-thumb-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width:200px;
    margin-bottom: 2rem;
}
.file-thumb {
    display: flex;
    justify-content: center;
    align-items: center;
    width:200px;
    margin-bottom: 10px;
    cursor: pointer;
}
::v-deep .file-thumb img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}
::v-deep .file-thumb .fa {
    font-size: 4em;
}
.file-name {
    width: 100%;
    word-wrap: break-word;
    overflow-wrap: break-word;
    word-break: break-all;
    text-align: center;
}
.background-image {
    width: 468px;
    height: 468px;
}
.button-container {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}
.select-button,
.upload-button {
    flex: 1;
}
</style>